import React from 'react';
import PropTypes from 'prop-types';
import TraderTable from './TraderTable';

export default function MaintainTraders(props) {
  const { companyId } = props;
  return (
    <div className="setting-header">
      <TraderTable companyId={companyId} />
    </div>
  );
}
MaintainTraders.propTypes = {
  companyId: PropTypes.string,
};
